import { connect } from "react-redux";
import React, { Component } from "react";
import { ReactTitle } from "react-meta-tags";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import LoginBlock from "../templates/loginForm";
import { withTranslation } from "react-i18next";
import Modal from "../../../utils/customModal";
import {
  encryptPassword,
  loadingHtml,
  errorContainer,
  customDecode,
} from "../../../utils/functions";
import { getEnvironment, getSpk } from "../../../../Redux/reducer/env";
import { getSessionCountry } from "../../../../Redux/reducer/session";
import * as sessionActions from "../../../../Redux/actions/sessionActions";

import Chrome from "../../../../../static/images/chrome.png";
import Mozilla from "../../../../../static/images/mozilla.png";
import Explorer from "../../../../../static/images/explorer.svg";
import AppName from "../../../../../static/images/appName.png";
import BscBackground from "../../../../../static/images/bsc-login-background.svg";
import CustomerLoginForm from "../templates/CustomerLoginForm";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      content: null,
      modalMessage: "",
      hideModal: undefined,
      httpResponseCode: 200,
      env: "",
    };
  }

  componentDidMount() {
    if (this.props.userType !== "BSC") {
      this.props.actions.setPage("login");
    } else {
      this.props.actions.setPage("bsc-login");
    }

    this.setState({ env: this.props.env });
    if (this.props.env === "prd") {
      this.props.actions.selectCountry("CR");
    }
  }

  loginAction = (username, password, codToken) => {
    const { login } = this.props.actions;
    const { t, spk, country, userType } = this.props;

    if (username != "" && password != "") {
      const encriptedUser = encryptPassword(username, spk);
      const encriptedPassword = encryptPassword(password, spk);
      this.setState({
        modal: true,
        content: loadingHtml(),
        hideModal: undefined,
      });
      return login({
        codUser: encriptedUser,
        access: encriptedPassword,
        codToken,
        country: country,
        typeUser: userType,
      })
        .then((response) => {
          var data = response.data.data;
          this.setState({ modal: false, httpResponseCode: 200 });
          // Redirigimos al usuario dependiendo del tipo de usuario

          const user = customDecode(data.jwt);

          switch (user.user_type) {
            case "PRO":
              return this.props.history.push("/providerSite/dashboard");
            case "CSA":
              return this.props.history.push("/dashboard");
            case "CASH":
              return this.props.history.push("/bscadministrator/home");
            case "CASC":
              return this.props.history.push("/bscadministrator/home");
            case "BSC":
              return this.props.history.push("/bscadministrator/home");
          }
          return true;
        })
        .catch((err) => {
          var buttons = {
            continueBtn: {
              action: () => this.setState({ modal: false }),
              text: `${t("general.buttons.tryAgain")}`,
            },
          };

          var title = `${t("login.errors.failTitle")}`;
          var message = `${t("login.errors.failMessage")}`;
          switch (err.response.status) {
            case 409:
              title = `${t("login.errors.409Title")}`;
              message = `${t("login.errors.409Message")}`;
              break;
          }
          // Errores de autenticación en caso de fallos del servicio

          this.setState({
            modal: true,
            content: errorContainer(title, message, buttons),
            hideModal: () => this.setState({ modal: false }),
            httpResponseCode: err.response.status,
          });
          return false;
        });
    }
  };

  render() {
    const { t, userType, redirectTo } = this.props;

    return (
      <div
        className={`wrapper-login ${
          userType === "BSC"
            ? ""
            : userType === "CSA"
            ? "clients-login-background"
            : "suppliers-login-background"
        }`}
      >
        <ReactTitle title={`${t("login.meta.title")} - ${t("appName")}`} />
        <header className="main-login-header">
          <div className="login-header-container">
            <div className="container-item">
              <div className="logo">
                <a href="/landing">
                  <img src={AppName} height={25} />
                </a>
              </div>
            </div>
            {userType === "BSC" && (
              <div className="browser">
                <p className="title">{t("login.bottom.advertisingText")}</p>
                <p className="browser-supported">
                  <img
                    src={Explorer}
                    alt="Navegadores soportados"
                  />{" "}
                  IE 11+
                </p>
                <p className="browser-supported">
                  <img
                    src={Mozilla}
                    alt="Navegadores soportados"
                  />{" "}
                  Mozilla Firefox
                </p>
                <p className="browser-supported">
                  <img src={Chrome} alt="Navegadores soportados" />{" "}
                  Google Chrome
                </p>
              </div>
            )}
            {userType !== "BSC" && (
              <div className="login-header-redirect">
                <p className="text-underline">
                  <Link
                    id={redirectTo}
                    to={{
                      pathname: `/${
                        redirectTo === "clients" ? "clients" : "providers"
                      }/login`,
                      // state: { userType: "CSA" },
                    }}
                  >
                    {`${
                      t("landing.goTo") +
                      " " +
                      t("appName") +
                      " - " +
                      t(`landing.options.${redirectTo}`)
                    }`}
                  </Link>
                </p>
              </div>
            )}
          </div>
        </header>
        <div
          className={`login-flex ${
            userType === "BSC"
              ? ""
              : userType === "CSA"
              ? "clients-login-form"
              : "suppliers-login-form"
          }`}
        >
          {userType === "BSC" && (
            <div className="background">
              <img src={BscBackground} />
              <h2>
                {t("landing.title")} <b>{t("appName")}</b>
              </h2>
            </div>
          )}
          <div
            className={`formulario ${
              ["CSA", "PRO"].includes(userType) ? "justify-space-between" : ""
            }`}
          >
            {userType === "BSC" && (
              <>
                <h1 className="init_session">{t(`login.title`)}</h1>
                {userType !== "BSC" && <h2>{`${t("appName")}`}</h2>}
                <h1 className="line red" />
                <h3 className="info_log">{t(`login.description`)}</h3>
                <LoginBlock
                  lblUsername={t(`login.forms.userLbl`)}
                  lblUserpass={t(`login.forms.passwordLbl`)}
                  lblActionBtn={t(`login.loginBtn`)}
                  btnAction={this.loginAction}
                  userType={userType}
                  env={this.props.env}
                />
              </>
            )}
            {["PRO", "CSA"].includes(userType) && (
              <CustomerLoginForm
                handleLogin={this.loginAction}
                userType={userType}
                redirectTo={redirectTo}
                httpResponseCode={this.state.httpResponseCode}
              />
            )}
            {userType === "BSC" && (
              <Modal show={this.state.modal} handleClose={this.state.hideModal}>
                {this.state.content}
              </Modal>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    env: getEnvironment(state),
    country: getSessionCountry(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(withTranslation()(LoginComponent))
);
